import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export const formatUtcToIstDateTime = (value) => {
	if (!value) return '-';

	const normalizedValue =
		typeof value === 'string' && !/[zZ]|[+-]\d{2}:\d{2}$/.test(value)
			? `${value.replace(' ', 'T')}Z`
			: value;

	const date = new Date(normalizedValue);
	if (Number.isNaN(date.getTime())) return value;

	return new Intl.DateTimeFormat('en-GB', {
		timeZone: 'Asia/Kolkata',
		day: '2-digit',
		month: 'short',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: false,
	})
		.format(date)
		.replace(',', '');
};

const formatPaymentStatus = (status) =>
	typeof status === 'string'
		? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
		: status;

const getFinalPaymentStatusColor = (status) =>
	formatPaymentStatus(status) === 'Pending' ? '#faad14' : '#52c41a';

export const getAdvanceColumnsConfig = () => [
	{
		title: 'Amount',
		dataIndex: 'amount',
		key: 'amount',
		render: (amt) => <Text strong>₹{amt}</Text>,
	},
	{ title: 'UTR Number', dataIndex: 'utr_number', key: 'utr_number' },
	{
		title: 'Paid At',
		dataIndex: 'paid_at',
		key: 'paid_at',
		render: (paidAt) => formatUtcToIstDateTime(paidAt),
	},
	{
		title: 'Status',
		dataIndex: 'status',
		key: 'status',
		render: (status) => (
			<span
				style={{
					color: '#1890ff',
					backgroundColor: '#e6f7ff',
					padding: '4px 8px',
					borderRadius: '4px',
					fontSize: '12px',
					fontWeight: 'bold',
				}}
			>
				{typeof status === 'string'
					? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
					: status}
			</span>
		),
	},
];

export const getFinalColumnsConfig = () => [
	{
		title: 'UTR NO',
		dataIndex: 'utr_no',
		key: 'utr_no',
		align: 'center',
	},
	{
		title: 'PAID AT',
		dataIndex: 'paid_at',
		key: 'paid_at',
		align: 'center',
		render: (paidAt) => formatUtcToIstDateTime(paidAt),
	},
	{
		title: 'STATUS',
		dataIndex: 'status',
		key: 'status',
		align: 'center',
		render: (status) => {
			const formattedStatus = formatPaymentStatus(status);
			const isPending = formattedStatus === 'Pending';
			return (
				<span
					style={{
						color: isPending ? '#faad14' : '#52c41a',
						backgroundColor: isPending ? '#fffbe6' : '#f6ffed',
						padding: '4px 8px',
						borderRadius: '4px',
						fontSize: '12px',
						fontWeight: 'bold',
					}}
				>
					{formattedStatus}
				</span>
			);
		},
	},
	{
		title: 'INV PAYMENT PROGRESS',
		dataIndex: 'progress_percent',
		key: 'progress_percent',
		align: 'center',
		render: (prog, record) => (
			<Text strong style={{ color: getFinalPaymentStatusColor(record?.status) }}>
				{prog}%
			</Text>
		),
	},
];
